<template>
  <PAccordion class="p-accordion-skeleton" value="0">
    <PAccordionPanel
      v-for="index in amount"
      :key="index"
      class="p-accordion-skeleton__panel"
      :value="index"
    >
      <PSkeleton :height="headerHeight" />
    </PAccordionPanel>
  </PAccordion>
</template>

<script setup lang="ts">
import PAccordionPanel from "primevue/accordionpanel";
import { computed } from "vue";

import PAccordion from "@/atoms/PAccordion.vue";
import PSkeleton from "@/atoms/PSkeleton.vue";

const props = withDefaults(
  defineProps<{ amount?: number; size?: "lg" | "md" | "sm" }>(),
  {
    amount: 5,
    size: "md",
  },
);

const headerHeight = computed(() => {
  if (props.size === "sm") {
    return "1.25rem";
  }
  if (props.size === "md") {
    return "1.5rem";
  }
  return "1.75rem";
});
</script>

<style lang="postcss">
.p-accordion-skeleton {
  &__panel {
    @apply p-[1.125rem];
  }
}
</style>
